var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5929 7.75851C20.586 7.75851 18.1485 10.2266 18.1485 13.271C18.1485 16.3155 20.586 18.7836 23.5929 18.7836C26.5999 18.7836 29.0374 16.3155 29.0374 13.271C29.0374 10.2266 26.5999 7.75851 23.5929 7.75851ZM14.5188 13.271C14.5188 8.19691 18.5815 4.0835 23.5929 4.0835C28.6043 4.0835 32.667 8.19691 32.667 13.271C32.667 18.3452 28.6043 22.4586 23.5929 22.4586C18.5815 22.4586 14.5188 18.3452 14.5188 13.271ZM19.8289 26.5101C20.2074 27.4498 19.7618 28.5222 18.8337 28.9053C14.6301 30.641 11.7966 34.5518 11.7966 38.996C11.7966 40.0108 10.9841 40.8335 9.98181 40.8335C8.97952 40.8335 8.16699 40.0108 8.16699 38.996C8.16699 32.8914 12.0525 27.7365 17.4632 25.5024C18.3913 25.1193 19.4505 25.5704 19.8289 26.5101Z",
    fill: "#030303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3091 38.2762L36.7724 39.0415C36.4628 39.1349 36.308 39.1816 36.1813 39.2743C36.0692 39.3564 35.9735 39.4642 35.9004 39.5907C35.8178 39.7337 35.7756 39.9088 35.6912 40.259L34.9999 43.1288L34.3265 40.2548C34.2444 39.904 34.2033 39.7287 34.1215 39.5852C34.0492 39.4582 33.9542 39.3498 33.8426 39.2671C33.7165 39.1736 33.562 39.1259 33.253 39.0306L30.7211 38.2494L33.2578 37.484C33.5674 37.3907 33.7222 37.3439 33.8488 37.2512C33.961 37.1692 34.0567 37.0614 34.1298 36.9349C34.2124 36.7919 34.2546 36.6168 34.3389 36.2666L35.0302 33.3968L35.7037 36.2708C35.7858 36.6215 35.8269 36.7969 35.9086 36.9404C35.981 37.0674 36.076 37.1758 36.1876 37.2585C36.3137 37.352 36.4682 37.3997 36.7772 37.495L39.3091 38.2762Z",
    fill: "#030303",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4350_27687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0965 39.3942L27.7765 39.7486C27.6154 39.7919 27.5349 39.8135 27.469 39.8565C27.4106 39.8945 27.3609 39.9445 27.3228 40.0031C27.2799 40.0694 27.2579 40.1506 27.2141 40.3129L26.8548 41.6433L26.5039 40.3107C26.4611 40.1481 26.4396 40.0668 26.3971 40.0002C26.3594 39.9413 26.31 39.8911 26.2519 39.8527C26.1862 39.8093 26.1058 39.7872 25.945 39.7429L24.6273 39.3803L25.9472 39.0259C26.1083 38.9827 26.1889 38.961 26.2548 38.9181C26.3131 38.8801 26.3629 38.8301 26.4009 38.7715C26.4439 38.7052 26.4658 38.624 26.5096 38.4616L26.8689 37.1312L27.2199 38.4639C27.2627 38.6265 27.2841 38.7078 27.3266 38.7743C27.3643 38.8332 27.4138 38.8835 27.4719 38.9219C27.5375 38.9652 27.6179 38.9874 27.7787 39.0316L29.0965 39.3942Z",
    fill: "#030303",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4350_27687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0186 32.2402L31.1551 32.73C30.9277 32.7898 30.814 32.8197 30.721 32.8791C30.6386 32.9316 30.5684 33.0007 30.5147 33.0818C30.454 33.1734 30.4231 33.2856 30.3612 33.51L29.8541 35.3491L29.3585 33.5069C29.2981 33.2821 29.2678 33.1697 29.2078 33.0777C29.1546 32.9963 29.0847 32.9268 29.0027 32.8737C28.91 32.8138 28.7965 32.7832 28.5695 32.722L26.7091 32.2206L28.5726 31.7308C28.8 31.671 28.9137 31.6412 29.0067 31.5818C29.0891 31.5292 29.1594 31.4602 29.213 31.3791C29.2737 31.2875 29.3046 31.1753 29.3665 30.9508L29.8736 29.1118L30.3692 30.954C30.4296 31.1788 30.4599 31.2912 30.52 31.3832C30.5731 31.4646 30.643 31.534 30.725 31.5871C30.8177 31.6471 30.9312 31.6777 31.1582 31.7389L33.0186 32.2402Z",
    fill: "#030303",
    stroke: "black",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4350_27687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.01618,
    height: 5.95901,
    fill: "white",
    transform: "translate(29.8506 36.3887) rotate(90.1784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4350_27687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.31648,
    height: 8.41272,
    fill: "white",
    transform: "translate(34.083 28.0854) rotate(90.1784)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentMarketplace);
export default __webpack_public_path__ + "static/media/agentMarketplace.21d7af8e2a650cba6c7bcceb128706a2.svg";
export { ForwardRef as ReactComponent };